import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import BillingReportForm from "../forms/BillingReportForm";

const BillingReportModal = ({ onClose }) => {
  return (
    <ModalWrapper
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      show={true}
      onClose={onClose}
      title="Generate Billing Report"
    >
      <BillingReportForm onClose={onClose} />
    </ModalWrapper>
  );
};

export default BillingReportModal;
